import useSWR, { SWRResponse } from 'swr'
import { fetcher } from 'common-code-react/utils/fetcher'
import { getFullUrl } from '../utils/getFullUrl'
import { Customer } from 'common-code-react/common-types/customer/customer'

export function useCustomer(token: string | null): SWRResponse<Customer> {
  const url = getFullUrl('/api/customer')
  return token ? useSWR(url, fetcher(token)) : useSWR(null)
}
